import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import type React from 'react';
import { useMemo } from 'react';

const styles = makeStyles((theme: Theme) => ({
  assetCount: {
    color: theme.palette.text.secondary,
    marginTop: '1em',
  },
}));

interface AssetCountProps extends React.HTMLAttributes<HTMLDivElement> {
  assetIds: string[];
  create?: boolean;
}

const AssetCount: React.FC<AssetCountProps> = ({ assetIds, create = true, ...props }) => {
  const classes = styles();

  const msg = useMemo(() => {
    const len = assetIds.length;
    return create ? `Gallery will have ${len} asset${len > 1 ? 's' : ''}` : `Add ${len} assets to an existing gallery`;
  }, [assetIds?.length, create]);

  return (
    <div className={classes.assetCount} {...props}>
      {msg}
    </div>
  );
};

export default AssetCount;
